$.fn.chServiceSubmit = function () {
    this.on('submit', function submit(e) {
        e.preventDefault();

        var form = $(e.target);

        var method = form.attr('method');
        if (!method) {
            method = 'POST';
        }

        clearErrors(form);

        var buttons = form
            .find('button[type=submit],input[type=submit]')
            .attr('disabled', 'disabled');

        $.ajax({
            type: method,
            url: form.attr('action'),
            data: form.serialize()
        })
            .done(function (data) {
                form.trigger('submit:success', data)
            })
            .fail(function (jqXHR) {
                if (jqXHR.status == 400) {
                    var errors = $.parseJSON(jqXHR.responseText);
                    displayErrors(form, errors);
                    form.trigger('submit:fail', [errors])
                } else {
                    alert('Unexpected error');
                    form.trigger('submit:fail', arguments)
                }
            })
            .always(function () {
                buttons.removeAttr('disabled');
            })
    });

    function displayErrors(form, data) {
        var alertPlaceholder = $('.validation-alert', form);
        var alert = null;

        if (alertPlaceholder.length) {
            alert = $('<div class="alert alert-danger validation-alert hidden"><div class="d-flex"><div class="flex-shrink-1"><i class="far fa-exclamation-triangle"></i></div><div class="flex-grow-1 alert-body d-block"><strong>Validation Errors</strong><div class="validation-summary-errors"><ul></ul></div></div></div>');
            alertPlaceholder.replaceWith(alert);
        }

        for (var i = 0; i < data.fields.length; i++) {
            var fieldData = data.fields[i];
            var field = $(document.getElementById(fieldData.key.replace(/\./g, '_')), form);
            var group = field.parents('.form-group');

            if (alert) {
                alert.removeClass('hidden');
                for (var j = 0; j < fieldData.errors.length; j++) {
                    var error = fieldData.errors[j];

                    var html = $('<li>')
                        .text(error.errorMessage)

                    $('ul', alert).append(html);
                }
            }

            if (field) {
                for (var j = 0; j < fieldData.errors.length; j++) {
                    var error = fieldData.errors[j];

                    var html = $('<div>')
                        .addClass('field-validation-error text-danger')
                        .text(error.errorMessage)

                    if (group.length === 1) {
                        group.append(html).addClass('error')
                    } else {
                        field.after(html);
                    }
                }
            }
        }
    }

    function clearErrors(form) {
        $('.field-validation-error', form).remove();
        $('.form-group.error', form).removeClass('error');
        $('.validation-alert', form).replaceWith('<div class="validation-alert hidden"></div>');
    }
};
